(() => {
  const SELECTOR = '[data-paper-stack]';
  const ITEM_SELECTOR = '[data-paper-stack-item]';

  const prepareSection = (section) => {
    if (!section || section.dataset.paperStackReady === 'true') return;

    section.dataset.paperStackReady = 'true';
    section.querySelectorAll(ITEM_SELECTOR).forEach((item, index) => {
      item.style.setProperty('--paper-stack-index', index);
    });
  };

  const revealSection = (section) => {
    prepareSection(section);
    section.classList.add('is-paper-stack-visible');
    window.setTimeout(() => {
      section.classList.add('is-paper-stack-complete');
    }, 1400);
  };

  const init = (root = document) => {
    const sections = Array.from(root.querySelectorAll(SELECTOR));

    if (root.matches && root.matches(SELECTOR)) {
      sections.unshift(root);
    }

    sections.forEach(prepareSection);

    if (!('IntersectionObserver' in window)) {
      sections.forEach(revealSection);
      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          revealSection(entry.target);
          currentObserver.unobserve(entry.target);
        });
      },
      {
        threshold: 0.34,
        rootMargin: '0px 0px -22% 0px',
      }
    );

    sections.forEach((section) => {
      if (section.classList.contains('is-paper-stack-visible')) return;
      observer.observe(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
